import React from 'react';
import { Table, Button } from 'antd';
import settings from 'front-settings';

import styles from './Statistics.module.scss';

const defaultColumns = year => [{
  title: `Année ${year}`,
  dataIndex: 'quarter',
  key: 'quarter',
}, {
  title: 'Catégorie d\'activités',
  dataIndex: 'category',
  key: 'category',
}, {
  title: 'Sous-catégories d\'activités',
  dataIndex: 'subCategory',
  key: 'subCategory',
}];

const optionalColumns = {
  events: {
    title: 'Événements',
    dataIndex: 'events',
    key: 'events',
  },
  participants: {
    title: 'Participants',
    dataIndex: 'participants',
    key: 'participants',
  },
};

const getColumns = (displayKey = 'events', year) => ([
  ...defaultColumns(year),
  optionalColumns[displayKey],
]);

const handleCSVExportClick = year => () => {
  global.location = `${settings.API_URL}/datastore/onf.statistics.${year}/?format=csv`;
};

export const StatsAsTable = ({ data, displayKey, year }) => (
  <div>
    <div className={styles.export}>
      <Button type="export" icon="download" onClick={handleCSVExportClick(year)}>Exporter en format CSV</Button>
    </div>
    <Table
      className={styles.table}
      dataSource={data}
      columns={getColumns(displayKey, year)}
      size="middle"
    />
  </div>
);

export default StatsAsTable;



// WEBPACK FOOTER //
// ./src/components/Statistics/StatsAsTable.js